<template>
  <div id="platforml-bar" class="chartheight" :style="{ width: '100%' }"></div>
</template>

<script>
export default {
  props: {
    platform: null,
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("platforml-bar"),
        "light"
      ); //初始化echats实例
      var dataReset = [
        { value: this.platform.topWhiteCollarCount },
        { value: this.platform.littleWhiteCollarCount },
        { value: this.platform.tyrantCount },
        { value: this.platform.tinyIncomeCount },
        { value: this.platform.blueCollarCount },
        { value: this.platform.unknownCount },
      ];
      var datasetReset = [
        "高级白领",
        "小白领",
        "土豪",
        "收入很少",
        "蓝领",
        "未识别",
      ];
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        xAxis: {
          type: "category",
          data: datasetReset,
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 10,
          bottom: 0,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666",
                    fontSize: 14,
                  },
                },
                color: function (params) {
                  var colorList = [
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                    "#7f86ea",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            data: dataReset,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight {
  height: 300px;
  @media screen and (max-width: 1400px) {
    margin-top: 10px;
    height: 250px;
  }
  @media screen and (max-width: 1340px) {
    margin-top: 10px;
    height: 230px;
  }
}
</style>
